'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const DonutInner = dynamic(() => import('./CampaignStatusDonutInner'), { ssr: false });

export default function CampaignStatusDonut() {
  return <DonutInner />;
}